import React from 'react';
import ContentApp from "../../components/ContentApp";
export default class extends React.Component {
    render() {
        return (
            <div>
                <div className="site-layout-background" style={{ padding: "24px 0", minHeight: 360, maxWidth: '1224px', margin: 'auto' }}>
                   <ContentApp />
                </div>
            </div>
        );
    }
}
